module.exports = __webpack_public_path__ + "img/balkongelaender_rot.05c988b3.jpg";